export function isBody(elem: HTMLElement | Element): boolean {
	return elem === document.body;
}
